import { Badge } from '@/components/shadcn/badge'
import { ColumnDef, Row } from '@tanstack/react-table'
import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { ToolActionsMenu } from './ToolActionsMenu'
import { ExistingRegisteredTool, getModuleFilterValue } from './platformAgentToolsTableUtils'

const moduleMultiSelectFilter = (row: Row<ExistingRegisteredTool>, _columnId: string, filterValue: unknown) => {
  if (!Array.isArray(filterValue) || filterValue.length === 0) return true
  return (filterValue as string[]).includes(getModuleFilterValue(row.original))
}

export const toolColumns: ColumnDef<ExistingRegisteredTool>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: ({ column }) => <SortingHeaderButton column={column}>Tool</SortingHeaderButton>,
    cell: ({ row }) => (
      <div className="flex flex-col gap-y-1">
        <span className="text-base">{row.original.name}</span>
        <span className="text-xs font-light leading-[1.1] text-muted-foreground">
          {row.original.description || 'No description'}
        </span>
      </div>
    ),
    sortingFn: (rowA, rowB) => rowA.original.name.localeCompare(rowB.original.name),
  },
  {
    id: 'functionName',
    accessorKey: 'functionName',
    header: ({ column }) => <SortingHeaderButton column={column}>Function</SortingHeaderButton>,
    cell: ({ row }) => {
      const value = row.original.functionName || 'Not set'
      return (
        <Badge variant="outline" className="max-w-full truncate font-normal">
          {value}
        </Badge>
      )
    },
    sortingFn: (rowA, rowB) => (rowA.original.functionName || '').localeCompare(rowB.original.functionName || ''),
  },
  {
    id: 'moduleName',
    accessorKey: 'moduleName',
    header: ({ column }) => <SortingHeaderButton column={column}>Module</SortingHeaderButton>,
    cell: ({ row }) => {
      const value = row.original.moduleName || 'Not set'
      return (
        <Badge variant="secondary" className="max-w-full truncate font-normal">
          {value}
        </Badge>
      )
    },
    sortingFn: (rowA, rowB) => (rowA.original.moduleName || '').localeCompare(rowB.original.moduleName || ''),
    filterFn: moduleMultiSelectFilter,
    enableGlobalFilter: true,
  },
  {
    id: 'defaultSystemPrompt',
    accessorKey: 'defaultSystemPrompt',
    header: ({ column }) => <SortingHeaderButton column={column}>Default Prompt</SortingHeaderButton>,
    cell: ({ row }) => (
      <span className="line-clamp-2 text-sm text-muted-foreground">
        {row.original.defaultSystemPrompt || 'No default prompt'}
      </span>
    ),
    sortingFn: (rowA, rowB) =>
      (rowA.original.defaultSystemPrompt || '').localeCompare(rowB.original.defaultSystemPrompt || ''),
  },
  {
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <div className="flex justify-end pr-5">
        <ToolActionsMenu tool={row.original} />
      </div>
    ),
  },
]
